import { Title, TitleProps } from "@mantine/core";
import { ReactElement } from "react";

export default function ModalTitle({
  children,
  ...titleProps
}: Omit<TitleProps, "c" | "order" | "size">): ReactElement {
  return (
    <Title c="gray.6" order={6} size="h4" {...titleProps}>
      {children}
    </Title>
  );
}
